import { __rest } from './../../external/tslib/tslib.es6.js';
import React from 'react';
import { MoreHorizontalFill, SuccessOutline } from '@olist/design-system-icons';
import { StepStatus } from './interfaces.js';
import { Wrapper, StepsList, AccessibilityStep, StepsListItem, StepsListWrapperItems, Bullet } from './styles.js';
import { useCountSteps } from './useCountSteps.js';
import '../Text/Caption/Caption.js';
import '../Text/DetailedSubheading/DetailedSubheading.js';
import '../Text/OverlineLg/OverlineLg.js';
import '../Text/OverlineMd/OverlineMd.js';
import ParagraphLg from '../Text/ParagraphLg/ParagraphLg.js';
import '../Text/ParagraphMd/ParagraphMd.js';
import '../Text/SectionHeading/SectionHeading.js';
import '../Text/SectionSubheading/SectionSubheading.js';
import '../Text/Title/Title.js';

function Steps(_a) {
    var { vertical, currentStep = 0, stepList, compact = false, isCompleted = false } = _a, props = __rest(_a, ["vertical", "currentStep", "stepList", "compact", "isCompleted"]);
    const { uiItemList } = useCountSteps({
        stepList,
        currentStepIndex: currentStep,
    });
    return (React.createElement(Wrapper, Object.assign({ vertical: vertical }, props),
        React.createElement(StepsList, { vertical: vertical }, uiItemList === null || uiItemList === void 0 ? void 0 : uiItemList.map((item) => {
            const itemIndex = stepList.findIndex((step) => step.key === item.key);
            const currentStepIndex = stepList.findIndex((step) => step.key === currentStep);
            const activeStep = typeof currentStep === 'number' && currentStep === item.key;
            const doneStep = !item.etc &&
                typeof item.key === 'number' &&
                itemIndex < currentStepIndex;
            const statusResolve = (activeStep && currentStep >= 1) ||
                (currentStep === 0 && !item.etc && item.key === 0)
                ? StepStatus.active
                : (doneStep && StepStatus.done) || StepStatus.todo;
            const isGroupedItem = !!item.etc || !!item.etcDone;
            const keyText = isGroupedItem ? (React.createElement(AccessibilityStep, null, item.key)) : (React.createElement(ParagraphLg, { bold: true }, item.key));
            return (React.createElement(StepsListItem, { key: item.key, title: item.stepName, "aria-current": activeStep ? 'step' : undefined, vertical: vertical, status: isCompleted ? StepStatus.done : statusResolve, etcDone: item.etcDone },
                React.createElement(StepsListWrapperItems, { vertical: !!vertical, status: isCompleted ? StepStatus.done : statusResolve, etcDone: item.etcDone },
                    React.createElement(Bullet, null,
                        item.etc && React.createElement(MoreHorizontalFill, { "aria-hidden": true }),
                        doneStep || isCompleted ? (React.createElement("span", null,
                            React.createElement(SuccessOutline, { "aria-hidden": true }),
                            React.createElement(AccessibilityStep, null, item.key))) : (keyText)),
                    !compact && !isCompleted && (vertical || activeStep) ? (React.createElement(ParagraphLg, { bold: true }, item.stepName)) : null)));
        }))));
}

export { Steps };
